export function getShiftLaborLawViolations(laborLawViolations, shifts) {
  const shiftIds = new Set(
    (shifts || [])
      .map((shift) => shift?.id)
      .filter((shiftId) => shiftId !== null && shiftId !== undefined)
      .map(String)
  );

  if (shiftIds.size === 0) return [];

  return (laborLawViolations || []).filter((violation) =>
    (violation?.shifts || []).some((shift) =>
      shift?.id !== null &&
      shift?.id !== undefined &&
      shiftIds.has(String(shift.id))
    )
  );
}

export function getLaborLawViolationLabel(violation) {
  if (violation?.title) return violation.title;
  if (violation?.description) return violation.description;

  const regulationName = violation?.regulation_type
    ? violation.regulation_type
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : "Labor law";

  return `${regulationName} warning`;
}
